import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-28 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className="ri-film-line text-3xl"></i>
      </span>
      <h1 className="mt-6 text-2xl text-foreground-950">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已经下线，不妨回首页继续挑选今晚的午夜影片。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-white transition hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>返回首页
        </Link>
        <Link
          to="/search"
          className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 text-sm text-foreground-700 transition hover:text-foreground-950"
        >
          去搜索影片
        </Link>
      </div>
    </div>
  );
}